export default __webpack_public_path__ + "static/media/53_BottomLeftSquares_RotateLeft.b4385767.mp4";